// Form validation rules — identical in both portals
// Source: apps/*/src/util/util.tsx

export const passwordRules = [
  { min: 8, message: "Password must be at least 8 characters long." },
  {
    pattern: /[A-Z]/,
    message: "Password must include at least one uppercase letter.",
  },
  {
    pattern: /[a-z]/,
    message: "Password must include at least one lowercase letter.",
  },
  { pattern: /\d/, message: "Password must include at least one number." },
  {
    pattern: /[!@#$%^&*(),.?":{}|<>+\-/;=[\]'_~]/,
    message: "Password must include at least one special character.",
  },
  {
    pattern: /^(?!\s)(?!.*\s$).*$/,
    message: "Password cannot have leading or trailing spaces.",
  },
];

export const confirmationCodeRules = [
  { required: true, message: "Please enter the confirmation code." },
  { len: 6, message: "Confirmation code must be exactly 6 characters." },
  {
    pattern: /^\d{6}$/,
    message: "Confirmation code must contain only digits.",
  },
];
